import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, formatDate, formatTime } from "../../../utils/const";
import { Box, CircularProgress, Typography } from "@mui/material";
import styles from "../InternalTracker.module.css";
import { useEffect } from "react";
import { getAllFeedbackMassase } from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../../redux/profile/profileSlice";

const CandidateFeedbackDrawer = ({
  handleClose,
  show,
  candidate,
  handleShowAddFeedback,
  handleShowAddFeedbackBenchSales,
  handleShowAddFeedbackRecruiter,
}) => {
  const dispatch = useDispatch();
  const oneSubmisionStatus = useSelector(
    (state) => state.trackersubmission.oneSubmisionStatus
  );
  const feedbackMassage = useSelector(
    (state) => state.trackersubmission.feedbackMassage
  );
  const profile = useSelector((state) => state.profile.data);

  useEffect(() => {
    if (candidate) {
      let subID = candidate?.submission_id;
      dispatch(getAllFeedbackMassase(subID));
    }
  }, [candidate]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "40%",
        padding: "0 0 0 10px",
        borderLeft: "1px solid #f2f2f2",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f2f2f2",
        }}
      >
        <Box className={styles.feedbackHeader}>
          <span>
            <Typography>
              <b>Feedback on {candidate?.full_name}</b>
            </Typography>
            <Typography>
              {candidate?.current_job_title}, Exp {candidate?.total_experience}{" "}
              {candidate?.total_experience > 0 ? "Years" : "Year"}
            </Typography>
          </span>
          <Box>
            {candidate?.bdm_user_id_for_feedback !== null &&
              profile?.profile?.role !== "BENCH_SALES_RECRUITER" && (
                <button onClick={handleShowAddFeedback}>Ask to BDM</button>
              )}
            {candidate?.bench_sale_user_id_for_feedback !== null &&
              profile?.profile?.role !== "BENCH_SALES_RECRUITER" && (
                <button
                  onClick={handleShowAddFeedbackBenchSales}
                  style={{ padding: "8px 4px", marginLeft: "10px" }}
                >
                  Ask to benchSales
                </button>
              )}
            {profile?.profile?.role === "BENCH_SALES_RECRUITER" && (
              <button
                onClick={handleShowAddFeedbackRecruiter}
                style={{ padding: "8px 8px", marginLeft: "10px" }}
              >
                Ask to IT Recruiter
              </button>
            )}
          </Box>
        </Box>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        {oneSubmisionStatus === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 230,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : feedbackMassage?.length > 0 ? (
          feedbackMassage?.map((chat) => {
            return (
              <Box className={styles.feedbackBody}>
                <span>
                  <Typography>
                    <b>
                      {chat?.chat_with?.fullName} - {chat?.chat_with?.role}
                    </b>
                  </Typography>
                  <Typography>{`${formatDate(chat?.timestamp)},${formatTime(
                    chat?.timestamp
                  )}`}</Typography>
                </span>
                <span>
                  <Typography>{chat?.message}</Typography>
                  {chat?.is_sender && (
                    <a style={{ textDecoration: "underline", color: "green" }}>
                      Replied
                    </a>
                  )}
                </span>
              </Box>
            );
          })
        ) : (
          <Typography sx={{ marginTop: "20px", textAlign: "center" }}>
            No Chat Found
          </Typography>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CandidateFeedbackDrawer;
